import { useDevice } from '@/hooks/useDevice'

export const copyText = (str: string) => {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input')
    input.value = str
    document.body.appendChild(input)
    input.select()
    if (document.execCommand('copy')) {
      document.execCommand('copy')
      document.body.removeChild(input)
      resolve(true)
    } else {
      reject(new Error('Copy failed'))
    }
  })
}

// 自定义数据上报事件
export const customEvent = (type: string, params: any) => {
  window.staticFn.customEvent(type, { ...params })
}

export const handleOpenUrl = (url: string, isMobile: boolean) => {
  const { isWeixin } = useDevice()
  const isAliPay = url?.includes('punchout_form') && url?.includes('alipay')

  // 国内PC微信支付需要在订单确认弹窗展示二维码,
  if (
    !isMobile &&
    (url?.includes('https://open.weixin.qq.com') ||
      url?.includes('cnp=qr') ||
      url?.includes('weixin://')) &&
    !isWeixin.value
  ) {
    return
  }

  if (isAliPay) {
    const $div = document.createElement('div')
    $div.innerHTML = url
    document.body.appendChild($div)
    if (!isMobile) {
      $div.querySelector('form')!.target = '_blank'
    }
    $div!.querySelector('form')!.submit()
    return
  }

  if (isMobile) {
    window.location.href = url
  } else {
    const link = document.createElement('a')
    link.setAttribute('href', url)
    link.setAttribute('target', '_blank')
    link.click()
    link.addEventListener('click', () => {
      link.remove()
    })
  }
}

/* 判断客户端 */
export const judgeClient = () => {
  const { isIOS, isAndroid, isWeixin } = useDevice()
  console.log(`是否是微信：${isWeixin.value}`) // true,false
  console.log(`是否是Android：${isAndroid.value}`) // true,false
  console.log(`是否是iOS：${isIOS()}`)
  // 微信内浏览器环境
  if (isWeixin.value) {
    return 2
  }
  if (isAndroid.value) {
    return 0
  }
  if (isIOS()) {
    return 1
  }
  return 2
}

// 防抖函数
export const debounce = (fn: Function, delay: number = 200) => {
  let timer: any
  return (...args: any[]) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = null
      return fn(...args)
    }, delay)
  }
}

// 华为云图片压缩技术
export function imgLimit(url: string) {
  if (!url) {
    return ''
  }
  try {
    const hasP = url.indexOf('?') > -1
    return `${url}${hasP ? '&' : '?'}x-image-process=image/format,webp`
  } catch (error) {
    return url
  }
}
